import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Globals {
  /* Nombre de los bancos aliados */
  public BANCAMIA = 'Bancamia';
  public BAN100 = 'Ban100';
  public BANCOW = 'Banco W';
  public COLTEFINANCIERA = 'Coltefinanciera';
  public FLAMINGO = 'Flamingo';
  public MIBANCO = 'MiBanco';
  public MUNDOMUJER = 'Mundo Mujer';
  public BANCO_MUNDO_MUJER = 'Banco Mundo Mujer';
  public DANNREGIONAL = 'Dann Regional';
  public FINANCIERA_DANN_REGIONAL = 'Financiera Dann Regional';
  public IBRBAN100 = 'IBR Ban100';
  public IPCBANCOW = 'IPC Banco W';
  public CREDIFAMILIA = 'Credifamilia';
  public FINANDINA = 'Banco Finandina';
  public KOA = 'KOA';
  public BANCOUNION = 'Banco Union';
  /* ID de los bancos aliados */
  public ID_BANCAMIA = 11;
  public ID_BAN100 = 8;
  public ID_BANCOW = 15;
  public ID_COLTEFINANCIERA = 24;
  public ID_FLAMINGO = 27;
  public ID_MIBANCO = 10;
  public ID_MUNDOMUJER = 13;
  public ID_DANNREGIONAL = 28;
  public ID_IBRBAN100 = 8;
  public ID_IPCBANCOW = 15;
  public ID_CREDIFAMILIA = 29;
  public ID_FINANDINA = 22;
  public ID_KOA = 31;
  public ID_BANCOUNION = 34;
  /* Temas para Transloco */
  public CAMPAIGN_FLAMINGO = 'Flamingo';
  public CAMPAIGN_MEJORCDT = 'MejorCDT';
  public CAMPAIGN_CLAUDIAURIBE = 'ClaudiaUribe';
  /* Nombre de Bancos no aliados */
  public BOGOTA = 'Bogota';
  public DAVIVIENDA = 'Davivienda';
  public DAVIBANK = 'Davibank';
  /* simulate Investment */
  public EXCLUDE_ONYL_SIMULATE = [25, 26, 27, 9, 21, 2, 30];
  public TERM_GLOBAL = 360;
  public POSITION_NAV_MOBILE = 2;
  public LIST_TERMS_GLOBAL = [90, 180, 270, 360, 720];
  public AMOUNT_GLOBAL = 10000000;

  /* public FORM_ID_DATOS_PERSONALES = 113; */
  public FORM_ID_DATOS_PERSONALES = 114;
  public FORM_ID_DATOS_FINANCIEROS = 101;
  public FORM_ID_PREGUNTAS_BAN100 = 9;
  public FORM_ID_PREGUNTAS_BANCAMIA = 18;
  public FORM_ID_PREGUNTAS_BANCOW = 14;
  public FORM_ID_PREGUNTAS_CDTURBO = 202;
  public FORM_ID_PREGUNTAS_COLTEFINANCIERA = 8;
  public FORM_ID_PREGUNTAS_CREDIFAMILIA = 19;
  public FORM_ID_PREGUNTAS_DANNREGIONAL = 15;
  public FORM_ID_PREGUNTAS_FLAMINGO = 13;
  public FORM_ID_PREGUNTAS_KOA = 21;
  public FORM_ID_PREGUNTAS_MIBANCO = 16;
  public FORM_ID_PREGUNTAS_MUNDOMUJER = 17;
  public FORM_ID_PREGUNTAS_BANCOUNION = 22;

  public PATHS_SHOW_DOWNLOAD_APP_FULLSCREEN = ['/', '/ahorro', '/mejores-bancos-para-cdt-hoy', '/portal/dashboard'];
  public PATHS_FORM_MINUTES = [
    '/a-unos-minutos-de-abrir-tu-cdt',
    '/mejores-bancos-para-cdt-hoy',
    '/beneficios-ban100',
    '/cdt-turbo',
    '/facil-cdt',
    '/',
  ];
  public PATHS_CONFIRM_PROCESS_EXIT = [
    '/preguntas-ban100',
    '/preguntas-bancamia',
    '/preguntas-bancow',
    '/preguntas-bancomundomujer',
    '/preguntas-mibanco',
    '/preguntas-coltefinanciera',
    '/preguntas-iris',
    '/datos-personales',
    '/datos-financieros',
    '/confirma-tus-datos',
    '/bienvenida-usuario-retorno',
    '/preguntas-credifamilia',
    '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
    '/v2/preguntas-ban100',
    '/v2/preguntas-bancamia',
    '/v2/preguntas-bancow',
    '/v2/preguntas-bancomundomujer',
    '/v2/preguntas-mibanco',
    '/v2/preguntas-credifamilia',
    '/v2/preguntas-coltefinanciera',
    '/v2/preguntas-iris',
    '/v2/preguntas-credifamilia',
    '/v2/preguntas-cdturbo',
    '/v2/preguntas-koa',
    '/v2/preguntas-bancounion',
    '/v2/datos-personales',
    '/v2/datos-financieros',
    '/asegura-tu-tasa',
    '/transfiere-el-dinero',
    '/validar-identidad',
  ];
}
